import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Brightness4Icon from "@mui/icons-material/DarkModeOutlined";
import Brightness7Icon from "@mui/icons-material/LightModeOutlined";
import { useTranslation } from "react-i18next";

export default function ThemeSwitcher({ toggleColorMode }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Tooltip
      title={t(
        isDark
          ? "themeSwitcher.lightModeTooltip"
          : "themeSwitcher.darkModeTooltip"
      )}
    >
      <IconButton
        onClick={toggleColorMode}
        sx={{ color: "primary.contrastText" }}
      >
        {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
}
